<template>
  <div>
    <a-form-model ref="ruleFormDetail" layout="inline" :model="detail" :rules="rules" :labelCol="{ style: { width: '120px' } }">
      <ls-card>
        <template #title>
          <div class="top-btn">
            <span>{{ status === "edit" ? "编辑计划选项" : "查看计划选项" }}</span>
            <span v-if="status === 'edit'">
              <a-button @click="handleCancel">取消</a-button>
              <a-button type="primary" class="ml10" :loading="saveLoading" @click="handleSave">保存</a-button>
            </span>
          </div>
        </template>
        <a-row class="top-line pt5 pb5">
          <a-col :md="7" :sm="24">
            <a-form-model-item label="计划名称">
              <global-select
                :value.sync="detail.planName"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :disabled="true"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="16" :sm="24">
            <a-form-model-item label="说明">
              <a-input v-model="detail.description" :disabled="status !== 'edit'" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="top-line pt5 pb5">
          <a-col :md="7" :sm="24">
            <a-form-model-item label="计划类型">
              <global-select
                :value.sync="detail.planType"
                :selectData="planTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :disabled="true"
                @change="detailPlanType"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <a-form-model-item label="失效时间">
              <a-date-picker v-model="detail.disableDate" :disabled="status !== 'edit'" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-tabs :default-active-key="currentTab" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.key"></a-tab-pane>
        </a-tabs>
      </ls-card>
      <ls-card v-if="currentTab === '基本信息'">
        <template #title>基本信息</template>
        <!-- 叫料 齐套 -->
        <div v-show="detail.planType === '102' || detail.planType === '103'">
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="计划展望期" prop="planningHorizonDays">
                <a-popover>
                  <template slot="content">
                    <p>用于配置计算多少天的工单齐套信息</p>
                  </template>
                  <a-input-number v-model="detail.planningHorizonDays" :min="0" :precision="0" :disabled="status !== 'edit'" /> 天
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="14" :sm="24" class="wipJobStatusList">
              <a-form-model-item label="工单状态" prop="wipJobStatusList">
                <a-popover>
                  <template slot="content">
                    <p>标识需参与齐套计算的工单状态范围</p>
                  </template>
                  <global-select
                    :value.sync="detail.wipJobStatusList"
                    selectType="selectMultiple"
                    :selectData="wipJobStatusList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                    :disabled="status !== 'edit'"
                    :maxTagCount="5"
                    :maxTagTextLength="6"
                  />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="需求时间类型" prop="demandDateType">
                <a-popover>
                  <template slot="content">
                    <p>以工序起始时间计算或以工单起始时间计算物料需求</p>
                  </template>
                  <global-select
                    :value.sync="detail.demandDateType"
                    selectType="select"
                    :selectData="demandDateTypeNameList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                    :disabled="status !== 'edit'"
                  />
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item :label="detail.planType === '102' ? '叫料提前天数' : '齐套提前天数'" prop="callMaterialLeadtime">
                <a-popover>
                  <template slot="content">
                    <p>{{ `以工单物料需求时间-此提前天数（排除休息日）作为${detail.planType === '102' ? '叫料' : '齐套'}计算的需求时间` }}</p>
                  </template>
                  <a-input-number v-model="detail.callMaterialLeadtime" :min="0" :precision="0" :disabled="status !== 'edit'" />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="计划结果保留天数" prop="historyRetentionDays" :labelCol="{ style: { width: '130px' } }">
                <a-popover>
                  <template slot="content">
                    <p>此计划结果数据需保留多长时间。注：系统始终保留最后一版数据（不受此条件约束），除非删除计划</p>
                  </template>
                  <a-input-number v-model="detail.historyRetentionDays" :min="0" :precision="0" :disabled="status !== 'edit'" />
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="14" :sm="24" class="noCallOrderStatusList">
              <a-form-model-item label="不参与原材料叫料工单" prop="noCallOrderStatusList">
                <global-select
                  :value.sync="detail.noCallOrderStatusList"
                  selectType="selectMultiple"
                  :selectData="noCallOrderStatusList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  :disabled="status !== 'edit'"
                  :maxTagCount="5"
                  :maxTagTextLength="6"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <!-- 其他 -->
        <div v-show="!(detail.planType === '102' || detail.planType === '103')">
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="计划展望期" prop="planningHorizonDays">
                <a-popover>
                  <template slot="content">
                    <p>用于配置计算多少天的工单齐套信息</p>
                  </template>
                  <a-input-number v-model="detail.planningHorizonDays" :min="0" :precision="0" :disabled="status !== 'edit'" /> 天
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="需求时间类型" prop="demandDateType">
                <a-popover>
                  <template slot="content">
                    <p>以工序起始时间计算或以工单起始时间计算物料需求</p>
                  </template>
                  <global-select
                    :value.sync="detail.demandDateType"
                    selectType="select"
                    :selectData="demandDateTypeNameList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                    :disabled="status !== 'edit'"
                  />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="供应链模型">
                <a-popover>
                  <template slot="content">
                    <p>标识是否使用供应链模型，以及使用的供应链模型</p>
                  </template>
                  <global-select
                    :value.sync="detail.assignmentSetId"
                    requestApi="/scp/scpMrpSrAssignmentSets/assignmentSetBox"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                    :disabled="status !== 'edit'"
                  />
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="计划结果保留天数" prop="historyRetentionDays" :labelCol="{ style: { width: '130px' } }">
                <a-popover>
                  <template slot="content">
                    <p>此计划结果数据需保留多长时间。注：系统始终保留最后一版数据（不受此条件约束），除非删除计划</p>
                  </template>
                  <a-input-number v-model="detail.historyRetentionDays" :min="0" :precision="0" :disabled="status !== 'edit'" />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="展开外部毛需求">
                <a-popover>
                  <template slot="content">
                    <p>标识外部供应商的需求是否继续展BOM获取集采/指定自采物料毛需求</p>
                  </template>
                  <a-switch :checked="detail.genExternalGrossDemand === 'Y'" :disabled="status !== 'edit'" @change="statusOnChange(detail, 'genExternalGrossDemand')" />
                </a-popover>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-model-item label="启用追溯">
                <a-popover>
                  <template slot="content">
                    <p>标识是否需生成供应需求的追溯信息</p>
                  </template>
                  <a-switch :checked="detail.peggingEnabled === 'Y'" :disabled="status !== 'edit'" @change="statusOnChange(detail, 'peggingEnabled')" />
                </a-popover>
              </a-form-model-item>
            </a-col> -->
          </a-row>
          <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="生成储备计划">
                <a-popover>
                  <template slot="content">
                    <p>标识是否需生成采购计划下达平台数据</p>
                  </template>
                  <a-switch :checked="detail.generatePurchasingPlan === 'Y'" :disabled="status !== 'edit'" @change="statusOnChange(detail, 'generatePurchasingPlan')" />
                </a-popover>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="生成要货计划">
                <a-popover>
                  <template slot="content">
                    <p>标识是否计算并生成外部供应商送货计划数据</p>
                  </template>
                  <a-switch :checked="detail.generateDeliveryPlan === 'Y'" :disabled="status !== 'edit'" @change="statusOnChange(detail, 'generateDeliveryPlan')" />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="plan-time pt5 pb5">计划时段</div>
          <!-- <a-row class="pt5 pb5">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="周起始时间" prop="weekStartDate">
                <a-popover>
                  <template slot="content">
                    <p>标识周第一天是周几</p>
                  </template>
                  <global-select
                    :value.sync="detail.weekStartDate"
                    selectType="select"
                    :selectData="weekStartDateList"
                    :selectItem="{ value: 'value', label: 'label' }"
                    :disabled="status !== 'edit'"
                  />
                </a-popover>
              </a-form-model-item>
            </a-col>
          </a-row> -->
          <div class="dwm dwm-title">
            <div class="dwm-item">天</div>
            <div class="dwm-item"><i class="toRequired">*</i>周</div>
            <div class="dwm-item">月</div>
          </div>
          <div class="dwm">
            <div class="dwm-item"><a-input-number v-model="detail.dailyCutoffBucket" :min="0" :precision="0" :disabled="true" /></div>
            <div class="dwm-item"><a-input-number v-model="detail.weeklyCutoffBucket" :min="0" :precision="0" :disabled="status !== 'edit'" /></div>
            <div class="dwm-item"><a-input-number v-model="detail.monthlyCutoffBucket" :min="0" :precision="0" :disabled="true" /></div>
          </div>
        </div>
      </ls-card>
      <ls-card v-if="currentTab === '计划组织'">
        <template #title>计划组织</template>
        <div><a-button type="primary" @click="$refs.jhzzCreateModal.show(detail)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanOrganizations:add']">添加组织</a-button></div>
        <a-table
          v-if="resetting"
          :columns="jhzzColumns"
          :loading="jhzzPageParams.tableLoading"
          :data-source="jhzzTableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1400 }"
        >
          <!-- 筛选 -->
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="p8"
          >
            <a-input
              :placeholder="`搜索 ${column.title}`"
              :value="selectedKeys[0]"
              class="search-tb1"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'jhzzPage', 'jhzzQueryParams')"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              class="search-tb2"
              @click="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'jhzzPage', 'jhzzQueryParams')"
            >搜索</a-button>
            <a-button size="small" class="w90" @click="() => handleReset(column.dataIndex, clearFilters, 'jhzzPage', 'jhzzQueryParams')">重置</a-button>
          </div>
          <template v-for="item in jhzzColumns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="handleDeleteJhzz(record)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanOrganizations:remove']">删除</a>
              </span>
              <span v-if="item.type === 'switch'">
                <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" :disabled="status !== 'edit'" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page ref="jhzzPage" :pageParams.sync="jhzzPageParams" @getList="jhzzGetList" />
        <mrp-jhzz-add ref="jhzzCreateModal" @handle-success="jhzzHandleOk" />
      </ls-card>
      <ls-card v-if="currentTab === '需求源'">
        <template #title>需求源</template>
        <div><a-button type="primary" @click="$refs.xqyCreateModal.show(detail)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanSchedules:add']">添加需求源</a-button></div>
        <a-table
          :columns="xqyColumns"
          :loading="xqyPageParams.tableLoading"
          :data-source="xqyTableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1400 }"
        >
          <template v-for="item in xqyColumns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="handleDeleteXqy(record)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanSchedules:remove']">删除</a>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page ref="xqyPage" :pageParams.sync="xqyPageParams" @getList="xqyGetList" />
        <mrp-xqy-add ref="xqyCreateModal" :planTypeList="planTypeList" @handle-success="xqyHandleOk" />
      </ls-card>
      <ls-card v-if="currentTab === '净值仓'">
        <template #title>净值仓</template>
        <a-table
          v-if="resetting"
          :columns="jzcColumns"
          :loading="jzcPageParams.tableLoading"
          :data-source="jzcTableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1400 }"
        >
          <!-- 筛选 -->
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="p8"
          >
            <div v-if="column.dataIndex === 'subinventoryType'" class="pb8">
              <global-select
                :value.sync="selectedKeys[0]"
                :selectData="subinventoryTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :placeholder="`选择 ${column.title}`"
              />
            </div>
            <div v-else-if="column.dataIndex === 'nettingType'" class="pb8">
              <global-select
                :value.sync="selectedKeys[0]"
                :selectData="nettingTypeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :placeholder="`选择 ${column.title}`"
              />
            </div>
            <a-input
              v-else
              :placeholder="`搜索 ${column.title}`"
              :value="selectedKeys[0]"
              class="search-tb1"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'jzcPage', 'jzcQueryParams')"
            />

            <a-button
              type="primary"
              icon="search"
              size="small"
              class="search-tb2"
              @click="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'jzcPage', 'jzcQueryParams')"
            >搜索</a-button>
            <a-button size="small" class="w90" @click="() => handleReset(column.dataIndex, clearFilters, 'jzcPage', 'jzcQueryParams')">重置</a-button>
          </div>
          <template v-for="item in jzcColumns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'switch'">
                <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" :disabled="status !== 'edit'" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ meaning(text, record, item.dataIndex) }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page ref="jzcPage" :pageParams.sync="jzcPageParams" @getList="jzcGetList" />
      </ls-card>
      <ls-card v-if="currentTab === '运行阶段'">
        <template #title>运行阶段</template>
        <div><a-button type="primary" @click="$refs.yxjdCreateModal.show(detail)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanStages:add']">添加阶段</a-button></div>
        <a-table
          :columns="yxjdColumns"
          :loading="yxjdPageParams.tableLoading"
          :data-source="yxjdTableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1400 }"
        >
          <template v-for="item in yxjdColumns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="$refs.yxjdEditCreateModal.show(record)" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanStages:edit']">编辑</a>
                <a @click="handleDeleteYxjd(record)" class="ml10" :disabled="status !== 'edit'" v-hasPermi="['scp:scpMrpPlanStages:remove']">删除</a>
              </span>
              <span v-if="item.type === 'switch'">
                <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" :disabled="status !== 'edit'" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page ref="yxjdPage" :pageParams.sync="yxjdPageParams" @getList="yxjdGetList" />
        <mrp-yxjd-add ref="yxjdCreateModal" :stageCodeList="stageCodeList" @handle-success="yxjdHandleOk" />
        <mrp-yxjd-edit ref="yxjdEditCreateModal" :stageCodeList="stageCodeList" @handle-success="yxjdHandleOk" />
      </ls-card>
      <add-delete-modal ref="addDeleteModal" />
    </a-form-model>
  </div>
</template>

<script>
import {
apiScpMrpPlansBasicInformation,
apiScpPlanMrpOrganizationsDelete,
apiScpPlanMrpOrganizationsUpdate,
apiScpPlanMrpSchedulesDelete,
apiScpMrpPlanSubinventoriesRequest,
apiScpMrpPlanSubinventoriesUpdate,
apiScpMrpPlanStagesDelete,
apiScpMrpPlanStagesUpdate,
apiScpMrpPlanStagesDetailRequest,
apiScpMrpPlansUpdate
} from '@/api/scp/planSetting/mrpPlanName'
import MrpJhzzAdd from './components/mrp-jhzz-add'
import MrpXqyAdd from './components/mrp-xqy-add'
import MrpYxjdAdd from './components/mrp-yxjd-add'
import MrpYxjdEdit from './components/mrp-yxjd-edit'
import AddDeleteModal from './components/add-delete-modal'
export default {
  // eslint-disable-next-line
  name: 'mrp-plan-name-detail',
  components: {
    MrpJhzzAdd,
    MrpXqyAdd,
    MrpYxjdAdd,
    MrpYxjdEdit,
    AddDeleteModal
  },
  data () {
    return {
      status: "",
      detailId: "",
      detail: {
        planName: "",
        description: "",
        planType: "102",
        disableDate: "",
        planningHorizonDays: "",
        wipJobStatusList: undefined,
        noCallOrderStatusList: undefined, // 不参与原材料叫料工单
        demandDateType: "",
        callMaterialLeadtime: "",
        historyRetentionDays: "",
        assignmentSetId: "",
        genExternalGrossDemand: "N",
        peggingEnabled: "N",
        generatePurchasingPlan: "N",
        generateDeliveryPlan: "N"
      },
      // 页签
      currentTab: "基本信息",
      tabList: [],
      tabList1: [
        { key: "基本信息" },
        { key: "计划组织" },
        { key: "净值仓" },
        { key: "运行阶段" }
      ],
      tabList2: [
        { key: "基本信息" },
        { key: "计划组织" },
        { key: "需求源" },
        { key: "净值仓" },
        { key: "运行阶段" }
      ],
      // 表单校验
      rules: {
        planningHorizonDays: [
          { required: true, message: '计划展望期不能为空', trigger: 'blur' }
        ],
        wipJobStatusList: [
          { required: true, message: '工单状态不能为空', trigger: 'change' }
        ],
        demandDateType: [
          { required: true, message: '需求时间类型不能为空', trigger: 'change' }
        ],
        // callMaterialLeadtime: [
        //   { required: true, message: `${ this.detailPlanType ? "叫料" : "齐套" }提前天数不能为空`, trigger: 'blur' }
        // ],
        historyRetentionDays: [
          { required: true, message: '计划结果保留天数不能为空', trigger: 'blur' }
        ]
        // weekStartDate: [
        //   { required: true, message: '周起始时间不能为空', trigger: 'blur' }
        // ]
      },
      // 周起始时间
      weekStartDateList: [
        { value: 1, label: "一" },
        { value: 2, label: "二" },
        { value: 3, label: "三" },
        { value: 4, label: "四" },
        { value: 5, label: "五" },
        { value: 6, label: "六" },
        { value: 7, label: "日" }
      ],
      planTypeList: [], // 计划类型
      wipJobStatusList: [], // 工单状态
      noCallOrderStatusList: [], // 不参与原材料叫料工单
      demandDateTypeNameList: [], // 需求时间类型
      // 计划组织
      jhzzQueryParams: {
        organizationCode: "",
        organizationName: ""
      },
      jhzzPageParams: {
        automatic: false,
        pageUrl: '/scp/scpPlanMrpOrganizations/list',
        tableLoading: false
      },
      jhzzTableList: [],
      jhzzColumns: [],
      jhzzColumns1: [
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      jhzzColumns2: [
        {
          title: '净WIP',
          dataIndex: 'considerWip',
          align: 'center',
          scopedSlots: { customRender: 'considerWip' },
          type: "switch"
        },
        {
          title: '净采购',
          dataIndex: 'considerPo',
          align: 'center',
          scopedSlots: { customRender: 'considerPo' },
          type: "switch"
        },
        {
          title: '净预留',
          dataIndex: 'considerReservations',
          align: 'center',
          scopedSlots: { customRender: 'considerReservations' },
          type: "switch"
        },
        {
          title: '计划安全库存',
          dataIndex: 'planSafetyStock',
          align: 'center',
          scopedSlots: { customRender: 'planSafetyStock' },
          width: 180,
          type: "switch"
        }
      ],
      // 需求源
      xqyQueryParams: {},
      xqyPageParams: {
        automatic: false,
        pageUrl: '/scp/scpPlanMrpSchedules/list',
        tableLoading: false
      },
      xqyTableList: [],
      xqyColumns: [
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center'
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          title: '计划类型',
          dataIndex: 'scheduleType',
          align: 'center'
        },
        {
          title: 'MDS/MPS名称',
          dataIndex: 'scheduleName',
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'description',
          align: 'center'
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      // 净值仓
      jzcQueryParams: {
        organizationCode: "",
        organizationName: "",
        subinventoryType: "",
        subinventory: "",
        description: "",
        nettingType: ""
      },
      jzcPageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpPlanSubinventories/list',
        tableLoading: false
      },
      jzcTableList: [],
      jzcColumns: [
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '子库类型',
          dataIndex: 'subinventoryType',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown', customRender: 'subinventoryType' }
        },
        {
          title: '子库',
          dataIndex: 'subinventory',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '子库说明',
          dataIndex: 'description',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' },
          ellipsis: true
        },
        {
          title: '净值仓',
          dataIndex: 'nettingType',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown', customRender: 'nettingType' },
          type: "switch"
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        }
      ],
      subinventoryTypeList: [],
      nettingTypeList: [
        { realValue: "Y", label: "是" },
        { realValue: "N", label: "否" }
      ],
      // 运行阶段
      yxjdQueryParams: {
        planName: undefined
      },
      yxjdPageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpPlanStages/list',
        tableLoading: false
      },
      yxjdTableList: [],
      yxjdColumns: [
        {
          title: '序号',
          dataIndex: 'stageNumber',
          align: 'center'
        },
        {
          title: '阶段名称',
          dataIndex: 'stageCodeName',
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true
        },
        {
          title: '必须步骤',
          dataIndex: 'necessaryFlag',
          align: 'center',
          scopedSlots: { customRender: 'necessaryFlag' },
          type: "switch"
        },
        // {
        //   title: '自动执行下一步',
        //   dataIndex: 'nextStepFlag',
        //   scopedSlots: { customRender: 'nextStepFlag' },
        //   align: 'center',
        //   type: "switch"
        // },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      stageCodeList: [], // 阶段名称
      detailPrevious: null, // 上一级列表行带过来的数据
      resetting: true,
      saveLoading: false
    }
  },
  created () {
    this.status = this.$route.query.status || null;
    const row = JSON.parse(this.$route.query.row)
    this.detailId = row.id || null;
    this.detail.id = row.id || null;
    this.jhzzQueryParams.planName = row.planName
    this.xqyQueryParams.planName = row.planName
    this.jzcQueryParams.planName = row.planName
    this.yxjdQueryParams.planName = row.planName
    this.jhzzQueryParams.planVersion = row.planVersion || ""
    this.xqyQueryParams.planVersion = row.planVersion || ""
    this.jzcQueryParams.planVersion = row.planVersion || ""
    this.yxjdQueryParams.planVersion = row.planVersion || ""
    this.jhzzQueryParams.dataType = this.status === "edit" || this.status === "look" ? 1 : ""
    this.xqyQueryParams.dataType = this.status === "edit" || this.status === "look" ? 1 : ""
    this.jzcQueryParams.dataType = this.status === "edit" || this.status === "look" ? 1 : ""
    this.yxjdQueryParams.dataType = this.status === "edit" || this.status === "look" ? 1 : ""
    this.detailPrevious = row

    this.tabList = this.tabList1;
    this.tabOnchange("基本信息")
    this.getDetail()
    this.getLookupList('SCP_PLAN_TYPES', 'planTypeList')
    this.getLookupList('MES_JOB_STATUS', 'wipJobStatusList')
    this.getLookupList('MES_JOB_TYPE', 'noCallOrderStatusList')
    this.getLookupList('SCP_MRP_DEMAND_DATE_TYPE', 'demandDateTypeNameList')
    this.getLookupList('INV_SUBINVENTORY_TYPES', 'subinventoryTypeList')
    this.getLookupList('SCP_PLAN_PROG_STAGES', 'stageCodeList')
  },
  methods: {
    // 保存
    handleSave () {
      if (!this.detail.planType === '102' && !this.detail.planType === '103' && !this.detail.weeklyCutoffBucket) {
        this.$message.warning('周不能为空！')
        return
      }
      this.detail.genExternalGrossDemand = this.detail.genExternalGrossDemand ? this.detail.genExternalGrossDemand : "N"
      this.detail.peggingEnabled = this.detail.peggingEnabled ? this.detail.peggingEnabled : "N"
      this.detail.generatePurchasingPlan = this.detail.generatePurchasingPlan ? this.detail.generatePurchasingPlan : "N"
      this.detail.generateDeliveryPlan = this.detail.generateDeliveryPlan ? this.detail.generateDeliveryPlan : "N"
      this.$refs.ruleFormDetail.validate(valid => {
        if (valid) {
          this.saveLoading = true
          this.detail.weekStartDate = this.detail.weekStartDate ? this.detail.weekStartDate : "0"
          this.detail.dailyCutoffBucket = this.detail.dailyCutoffBucket ? this.detail.dailyCutoffBucket : "0"
          this.detail.monthlyCutoffBucket = this.detail.monthlyCutoffBucket ? this.detail.monthlyCutoffBucket : "0"
          apiScpMrpPlansUpdate(this.detail).then(response => {
            if (response.code === 200) {
              this.$message.success('保存成功')
            } else {
              this.$message.error(response.msg)
            }
            this.saveLoading = false
          }).catch(e => {
            this.saveLoading = false
          })
        } else {
          this.$message.error('校验失败')
        }
      })
    },
    // 取消
    handleCancel () {
      this.event.$emit("close-current-page");
    },
    // 重置
    reset () {
      if (this.currentTab !== "计划组织") {
        this.jhzzQueryParams = {
          organizationCode: "",
          organizationName: "",
          planName: this.detailPrevious.planName,
          planVersion: this.detailPrevious.planVersion || "",
          dataType: this.status === "edit" || this.status === "look" ? 1 : ""
        }
      }
      if (this.currentTab !== "净值仓") {
        this.jzcQueryParams = {
          organizationCode: "",
          organizationName: "",
          subinventoryType: "",
          subinventory: "",
          description: "",
          nettingType: "",
          planName: this.detailPrevious.planName,
          planVersion: this.detailPrevious.planVersion || "",
          dataType: this.status === "edit" || this.status === "look" ? 1 : ""
        }
      }
    },
    // 页签-切换
    tabOnchange (val) {
      this.currentTab = val
      this.resetting = false
      setTimeout(() => {
        this.resetting = true
      }, 0)
      if (val === "基本信息") {}
      if (val === "计划组织") {
        this.$nextTick(() => {
          this.$refs.jhzzPage.getFirstPage(this.jhzzQueryParams)
        })
      }
      if (val === "需求源") {
        this.$nextTick(() => {
          this.$refs.xqyPage.getFirstPage(this.xqyQueryParams)
        })
      }
      if (val === "净值仓") {
        this.scpMrpPlanSubinventoriesRequests(this.jzcQueryParams)
        this.$nextTick(() => {
          this.$refs.jzcPage.getFirstPage(this.jzcQueryParams)
        })
      }
      if (val === "运行阶段") {
        this.scpMrpPlanStagesDetailRequests(this.yxjdQueryParams)
        this.$nextTick(() => {
          this.$refs.yxjdPage.getFirstPage(this.yxjdQueryParams)
        })
      }
      this.reset()
    },
    // 计划类型
    detailPlanType () {
      if (this.detail.planType === "102" || this.detail.planType === "103") {
        this.tabList = this.tabList1;
        this.currentTab = this.currentTab === "需求源" ? "基本信息" : this.currentTab
        this.jhzzColumns = JSON.parse(JSON.stringify(this.jhzzColumns1));
      }

      if (this.detail.planType === "102") {
        return '叫料'
      }
      if (this.detail.planType === "103") {
        return '齐套'
      }

      const arr1 = JSON.parse(JSON.stringify(this.jhzzColumns1))
      const arr2 = JSON.parse(JSON.stringify(this.jhzzColumns2))
      arr1.splice(2, 0, ...arr2);
      this.jhzzColumns = arr1

      this.tabList = this.tabList2;
      return ""
    },
    statusOnChange (detail, val) {
      detail[val] = detail[val] === 'Y' ? 'N' : 'Y'
    },
    statusTableOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
      // 计划组织列表切换按钮
      if (this.currentTab === '计划组织') {
        apiScpPlanMrpOrganizationsUpdate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(response.msg)
          }
          this.$refs.jhzzPage.getData(this.jhzzQueryParams)
        }).catch(e => {
          this.$refs.jhzzPage.getData(this.jhzzQueryParams)
        })
      }
      if (this.currentTab === '净值仓') {
        apiScpMrpPlanSubinventoriesUpdate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(response.msg)
          }
          this.$refs.jzcPage.getData(this.jzcQueryParams)
        }).catch(e => {
          this.$refs.jzcPage.getData(this.jzcQueryParams)
        })
      }
      if (this.currentTab === '运行阶段') {
        apiScpMrpPlanStagesUpdate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(response.msg)
          }
          this.$refs.yxjdPage.getData(this.yxjdQueryParams)
        }).catch(e => {
          this.$refs.yxjdPage.getData(this.yxjdQueryParams)
        })
      }
    },
    // table 头筛选-搜索
    handleSearch (selectedKeys, dataIndex, confirm, refName, queryParamsName) {
      confirm();
      this[queryParamsName][dataIndex] = selectedKeys[0]
      this.$refs[refName].getFirstPage(this[queryParamsName])
    },
    // table 头筛选-重置
    handleReset (dataIndex, clearFilters, refName, queryParamsName) {
      clearFilters();
      this[queryParamsName][dataIndex] = ""
      this.$refs[refName].getFirstPage(this[queryParamsName])
    },
    // ****************************基本信息************************
    getDetail () {
      apiScpMrpPlansBasicInformation(this.detailId).then(res => {
        if (res.code === 200 && res.data) {
          const obj = res.data
          obj.wipJobStatusList = obj.wipJobStatusList ? obj.wipJobStatusList : undefined
          obj.planName = this.detailPrevious.planName
          obj.description = this.detailPrevious.description
          obj.planType = this.detailPrevious.planType
          obj.disableDate = this.detailPrevious.disableDate
          obj.id = this.detailPrevious.id
          this.detail = obj
        } else {
          this.detail = this.detailPrevious
        }
        this.detail.noCallOrderStatusList = this.detail?.noCallOrderStatusList || undefined
        // 工单状态默认值
        if (!this.detail.wipJobStatusList || this.detail.wipJobStatusList.length === 0) {
          const arr = []
          this.wipJobStatusList.forEach(element => {
            arr.push(element.lookupCode)
          });
          this.detail.wipJobStatusList = arr
        }

        this.detail.historyRetentionDays = this.detail.historyRetentionDays ? this.detail.historyRetentionDays : 0

        this.detailPlanType()
      })
    },
    // ****************************计划组织************************
    jhzzGetList (data) {
      this.jhzzTableList = data
    },
    handleDeleteJhzz (row) {
      const self = this
      this.$confirm({
        title: '你确定要删除这行内容吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpPlanMrpOrganizationsDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.$refs.jhzzPage.getFirstPage(self.jhzzQueryParams)
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    jhzzHandleOk () {
      this.$refs.jhzzPage.getFirstPage(this.jhzzQueryParams)
    },
    // ****************************需求源************************
    xqyGetList (data) {
      this.xqyTableList = data
    },
    handleDeleteXqy (row) {
      const self = this
      this.$confirm({
        title: '你确定要删除这行内容吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpPlanMrpSchedulesDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.$refs.xqyPage.getFirstPage(self.xqyQueryParams)
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    xqyHandleOk () {
      this.$refs.xqyPage.getFirstPage(this.xqyQueryParams)
    },
    // ****************************净值仓************************
    meaning (text, record, dataIndex) {
      if (dataIndex === "subinventoryType") {
        return record.subinventoryTypeName
      }
      return text
    },
    jzcGetList (data) {
      this.jzcTableList = data
    },
    scpMrpPlanSubinventoriesRequests (val) {
      apiScpMrpPlanSubinventoriesRequest({ planName: this.detail.planName, planVersion: val.planVersion, dataType: val.dataType }).then((response) => {
        // this.$message.error(response.msg)
      })
    },
    // ****************************运行阶段************************
    yxjdGetList (data) {
      this.yxjdTableList = data
    },
    handleDeleteYxjd (row) {
      const self = this
      this.$confirm({
        title: '你确定要删除这行内容吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpMrpPlanStagesDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.$refs.yxjdPage.getFirstPage(self.yxjdQueryParams)
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    yxjdHandleOk () {
      this.$refs.yxjdPage.getFirstPage(this.yxjdQueryParams)
    },
    scpMrpPlanStagesDetailRequests (val) {
      apiScpMrpPlanStagesDetailRequest({ planName: this.detail.planName, planVersion: val.planVersion, dataType: val.dataType }).then((res) => {
        if (res.data && res.data.dele && res.data.dele.length > 0) {
          this.$refs.addDeleteModal.deleteShow(res.data.dele)
        }
        if (res.data && res.data.add && res.data.add.length > 0) {
          this.$refs.addDeleteModal.addShow(res.data.add)
        }
      })
    },
    // ****************************其他************************
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "MES_JOB_STATUS") {
          this[arr] = response.rows.filter((element) => element.attribute1 === "Y")

          // 工单状态默认值
          if (!this.detail.wipJobStatusList || this.detail.wipJobStatusList.length === 0) {
            const arr = []
            this.wipJobStatusList.forEach(element => {
              arr.push(element.lookupCode)
            });
            this.detail.wipJobStatusList = arr
          }
          return
        }
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select {
  width: 170px;
}
input {
  width: 170px;
}
/deep/.ant-input-number{
  width: 170px;
}
/deep/.ant-calendar-picker{
  width: 150px;
}
.top-line {
  // /deep/.ant-select {
  //   width: 150px;
  // }
  input {
    width: 500px;
  }
  // /deep/.ant-calendar-picker{
  //   width: 150px;
  // }
}
.wipJobStatusList {
  /deep/.ant-select {
    width: 450px;
  }
}
.noCallOrderStatusList{
  /deep/.ant-select {
    width: 450px;
  }
  /deep/ .ant-form-item-label{
    width: 180px !important;
  }
}
.pt5 {
  padding-top: 5px;
}
.pb5 {
  padding-bottom: 5px;
}
.top-btn{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.plan-time{
  font-size: 16px;
  font-weight: bold;
}
.dwm{
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  width: 600px;
  height: 50px;
}
.dwm-item{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dwm-title{
  background-color: rgb(250, 250, 250);
}
.p8 {
  padding: 8px
}
.search-tb1 {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-tb2 {
  width: 90px;
  margin-right: 8px
}
.pb8 {
  padding-bottom: 8px;
}
</style>
